export const validators = {
  IBAN: /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/,
  BIC: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  CITY: /^[a-zA-Z\s\-]+$/,
  ZIPCODE: /^\d+$/,
  END_CUSTOMER_ID: /^[A-Za-z0-9-]+$/,
  DIGITS_ONLY: /^[0-9]+$/,
};
